<template>
  <el-dialog :title="(type==='add')?'添加备注':'修改备注'" :visible.sync="shown" class="remarks-layer"
             ref="remarks" :before-close="()=>handleCancel('form')">
    <div class="remarks-layer-wrap">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item class="remarks-content" prop="comment">
          <el-input type="textarea" v-model="form.comment" maxlength="50"
                    placeholder="请输入内容(最大长度50个字符)" @input="changeInput()" />
        </el-form-item>
        <el-form-item class="button-box">
          <el-row class="button-box-inside" :gutter="40">
            <el-col :span="12">
              <el-button type="primary" @click="()=>handleSubmit('form')" v-if="(type==='add')">
                添加
              </el-button>
              <el-button type="primary" @click="()=>handleSubmitEditor('form')"
                         v-if="(type==='editor')">
                修改
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-button @click="()=>handleCancel('form')">取消</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "Remarks",
  props: ['shown', 'remarkInfo', 'type'],
  data () {
    return {
      form: {
        comment: ''
      },
      rules: {
        comment: [
          { required: true, message: '请填写备注信息', trigger: 'blur' }
        ]
      }
    }
  },

  watch: {
    remarkInfo (value) {
      this.form.comment = value.comment
    },
  },

  methods: {
    //去除左边空格
    changeInput () {
      this.form.comment = this.form.comment.replace(/^\s*/g, '');
    },
    //创建提交
    handleSubmit (formName) {
      const self = this;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      self.$refs[formName].validate((valid) => {
        Reflect.set((self.remarkInfo), 'commentType', 3);
        Reflect.set((self.remarkInfo), 'comment', self.form.comment);
        Reflect.set((self.remarkInfo), 'transFileId', (urlInfo.fileId));
        if (valid) {
          self.$store.dispatch('editor/setFragmentInfo', (self.remarkInfo)).then(({ success }) => {
            if (success) {
              self.handleCancel('form');
              //提交完成获取当前句的所有批注
              let params = { transFileId: (urlInfo.fileId) };
              let sentIdList = Array.of((self.remarkInfo.sentId));
              Reflect.set(params, 'sentIdList', sentIdList);
              self.$store.dispatch('editor/getCurrentRemarksInfo', params)
            } else {
              self.$message({
                message: '添加批注失败',
                type: 'warning'
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    //编辑提交
    handleSubmitEditor (formName) {
      const self = this;
      console.log(33)
      self.$refs[formName].validate((valid) => {
        Reflect.set((self.remarkInfo), 'comment', (self.form.comment));
        if (valid) {
          self.$store.dispatch('editor/updateSentRemarksInfo', (self.remarkInfo)).then((res) => {
            //成功后重新获取批注信息
            if (res) {
              let urlInfo = self.$store.getters['editor/getUrlInfo'];
              let sentIdList = Array.of((`${self.remarkInfo.sentId}`));
              let remarksParams = {
                transFileId: (urlInfo.fileId)
              };
              Reflect.set(remarksParams, 'sentIdList', sentIdList);
              this.$store.dispatch('editor/getCurrentRemarksInfo', remarksParams);
              self.handleCancel(formName)
            } else {
              self.$message({
                message: '修改批注失败',
                type: 'warning'
              });
            }
          })
        }
      })
    },

    //取消
    handleCancel (form) {
      this.$nextTick(() => {
        this.$refs[`${form}`].resetFields();
        this.$emit("handleCancel");
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>